import { render, staticRenderFns } from "./ForgotPassword.vue?vue&type=template&id=b0ce904a&scoped=true"
import script from "./ForgotPassword.vue?vue&type=script&lang=js"
export * from "./ForgotPassword.vue?vue&type=script&lang=js"
import style0 from "./ForgotPassword.vue?vue&type=style&index=0&id=b0ce904a&prod&scoped=true&lang=css"
import style1 from "./ForgotPassword.vue?vue&type=style&index=1&id=b0ce904a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0ce904a",
  null
  
)

export default component.exports